<template>
  <div class="create-company-page expande-horizontal centraliza">
    <v-flex xs12 md10 lg8>
      <v-card class="flow-shell" flat>
        <div class="payment-banner expande-horizontal wrap">
          <v-avatar size="48" color="rgba(255,255,255,0.2)" class="mr-3">
            <v-icon color="#fff" size="26">mdi-check-circle-outline</v-icon>
          </v-avatar>
          <div class="expande-horizontal column" style="flex-wrap: nowrap;">
            <span class="banner-title">Pagamento confirmado</span>
            <span class="banner-subtitle">Agora vamos cadastrar a sua empresa para liberar o acesso completo.</span>
          </div>
        </div>

        <div class="flow-content pa-5 pa-md-8">
          <div class="mb-4">
            <h2 class="section-title mb-1">Criacao da empresa</h2>
            <p class="section-subtitle mb-0">Leva menos de 2 minutos. Preencha os dados e finalize.</p>
          </div>

          <v-stepper v-model="step" flat class="custom-stepper">
            <v-stepper-header class="no-shadow" flat>
              <v-stepper-step step="1" :complete="step > 1" :color="$theme.primary">Senha</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="step > 2" :color="$theme.primary">Empresa</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="step === 3" :color="$theme.primary">Conclusao</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 pt-6">
                <v-form style="padding-top: 10px;" ref="criarSenha">
                  <v-text-field
                    v-model="payload.password"
                    :rules="[v => !!v || 'Preencha este campo']"
                    :color="$theme.primary"
                    label="Senha de acesso"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="changePassVisibility"
                    outlined
                    dense
                    :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                    prepend-inner-icon="mdi-lock-outline"
                  ></v-text-field>
                  <v-text-field
                    v-model="payload.confirmPassword"
                    :rules="[v => !!v || 'Preencha este campo']"
                    :color="$theme.primary"
                    label="Confirmar senha"
                    outlined
                    dense
                    @click:append="changePassVisibility"
                    :type="showPass ? 'text' : 'password'"
                    :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                    prepend-inner-icon="mdi-lock-check-outline"
                  ></v-text-field>
                </v-form>
              </v-stepper-content>

              <v-stepper-content step="2" class="pa-0 pt-6">
                <v-form ref="criarEmpresa">
                  <v-text-field
                    :color="$theme.primary"
                    dense
                    outlined
                    v-model="payload.name_market"
                    :rules="[v => !!v || 'Preencha este campo']"
                    label="Nome da empresa"
                    prepend-inner-icon="mdi-storefront-outline"
                  ></v-text-field>

                  <v-text-field
                    :color="$theme.primary"
                    dense
                    outlined
                    label="CNPJ"
                    :rules="[v => !!v || 'Preencha este campo']"
                    v-model="payload.cnpj_market"
                    v-mask="['##.###.###/####-##']"
                    prepend-inner-icon="mdi-card-account-details-outline"
                  ></v-text-field>
                </v-form>
              </v-stepper-content>

              <v-stepper-content step="3" class="pa-0 pt-6">
                <div class="expande-horizontal fonte column centraliza wrap success-state pa-6">
                  <v-avatar size="64" color="#e9f9ef" class="mb-4">
                    <v-icon color="#16a34a" size="34">mdi-check-circle-outline</v-icon>
                  </v-avatar>
                  <h2 class="text-center mb-2">Empresa configurada com sucesso</h2>
                  <span class="text-center success-description mb-5">
                    Sua assinatura ja esta ativa. Agora voce pode acessar o sistema e ajustar mais configuracoes da loja quando quiser.
                  </span>
                  <v-btn @click="$router.push('/')" :color="$theme.primary" class="text-none" dark large>
                    Acessar painel
                    <v-icon right size="18">mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <div v-if="step < 3" class="expande-horizontal pt-4">
            <v-btn
              v-if="step > 1"
              outlined
              class="text-none mr-2"
              @click="prevStep"
            >
              Voltar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click="nextPass"
              :loading="saving"
              :disabled="saving"
              :color="$theme.primary"
              class="text-none"
              dark
              large
            >
              {{ actionButtonLabel }}
              <v-icon right size="18">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      step: 1,
      showPass: false,
      saving: false,
      payload: {
        password: "",
        confirmPassword: "",
        cnpj_market: "",
        link_market: "",
        name_market: "",
        token: this.$route.query.token || "",
        photo_perfil: "",
        photo_capa: ""
      }
    };
  },
  computed: {
    passInputIsOk() {
      return this.payload.password === this.payload.confirmPassword;
    },
    actionButtonLabel() {
      return this.step === 2 ? "Finalizar cadastro" : "Continuar";
    }
  },
  methods: {
    ...mapActions(["createGlobalMessage", "create_market_with_token"]),
    changePassVisibility() {
      this.showPass = !this.showPass;
      this.$forceUpdate();
    },
    prevStep() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
    async nextPass() {
      if (this.step === 1) {
        if (!this.$refs.criarSenha.validate()) {
          return;
        }

        if (!this.passInputIsOk) {
          this.createGlobalMessage({
            message: "As senhas nao correspondem.",
            timeout: 3000,
            type: "warning"
          });
          return;
        }

        this.step = 2;
        return;
      }

      if (this.step === 2) {
        if (!this.$refs.criarEmpresa.validate()) {
          return;
        }

        this.saving = true;
        try {
          const res = await this.create_market_with_token(this.payload);
          if (res) {
            this.step = 3;
          }
        } catch (error) {
          console.log("error create market with token", error);
        }
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.create-company-page {
  min-height: 100vh;
  padding: 24px 12px;
  background: linear-gradient(180deg, #f5f7ff 0%, #eef2f9 100%);
}

.flow-shell {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid #e6ebf5;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.1);
}

.payment-banner {
  padding: 18px 24px;
  background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);
}

.banner-title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.banner-subtitle {
  color: #e6f2ff;
  font-size: 13px;
}

.flow-content {
  background: #fff;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
}

.section-subtitle {
  font-size: 14px;
  color: #64748b;
}

.custom-stepper {
  background: transparent;
}

.no-shadow {
  box-shadow: none;
}

.success-state {
  border: 1px solid #e5f5ea;
  border-radius: 14px;
  background: #fbfffd;
}

.success-description {
  max-width: 420px;
  color: #475569;
}
</style>
